import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { Document } from 'document/document';
import { DocumentI18n } from 'document/document-i18n';
import { DocumentOutput } from 'document/model/document.output';
import { DocumentType } from 'document/model/document.type';
import { DocumentConverterPort } from 'document/port/document-converter.port';

@Injectable()
export class DocumentConverterAdapter implements DocumentConverterPort {
	public documentAsEntity(output: DocumentOutput): Document {
		if (!output) {
			return null;
		}

		return new Document(
			output.id,
			output.ownerId,
			output.type,
			output.phase?.id,
			output.module?.id,
			output.section?.id,
			output.updateTimestamp,
			output.creationTimestamp,
			output.localizations.map(
				(loc) => new DocumentI18n(loc.url, loc.name, loc.locale)
			)
		);
	}

	public documentsAsEntities(outputs: DocumentOutput[]): Document[] {
		return reject(outputs, isNil).map((output) => this.documentAsEntity(output));
	}
}
